/*
 * Get-product.ts
 * Description: Includes the declaration
 * of the function for getting a certain product
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Product} from '@/ts/products/validate-product';

/**
 * Getting a certain product
 *
 * @return {Object} Promise - product data
 * @param {String} slug - id of a restaurant
 * @param {Number} productId - id of a category
 * @param {Product} data - product data to be updated
 */
export function getProduct(data: Product, slug: string, productId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/products/' + productId,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            // TODO: move this from here
            Object.assign(data, response.data.data.attributes);
            for (const item of response.data.included) {
                if (item.type === 'product-variations') {
                    data.variations.old.push({
                        id: item.id,
                        is_active: item.attributes.is_active,
                        price: item.attributes.price,
                        price_with_vat: item.attributes.price_with_vat,
                        weight: item.attributes.weight,
                        weight_unit: item.attributes.weight_unit,
                    });
                }
            }
            data.image = '';
            resolve(response.data.data.attributes);
        }).catch(() => {
            reject();
        });
    });
}
